import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { withAppLayout } from '../core/routes';
import SettingsPage from './pages/SettingsPage';
import SettingsWorkspacesPage from './pages/SettingsWorkspacesPage';
import ImprovementSuggestionsPage from './pages/ImprovementSuggestionsPage';
import CreateWorkspacePage from './pages/CreateWorkspacePage';

const OrderWorkflowSectionRedirect = () => {
  const { section } = useParams();
  return <Navigate to={`/orders/workflow/${encodeURIComponent(section)}`} replace />;
};

const OrderWorkflowEditorRedirect = () => {
  const { typeId } = useParams();
  return <Navigate to={`/orders/workflow/types/${encodeURIComponent(typeId)}/edit`} replace />;
};

export const settingsRoutes = [
  { path: '/settings', element: withAppLayout(<SettingsPage />) },
  { path: '/settings/workspaces', element: withAppLayout(<SettingsWorkspacesPage />) },
  { path: '/settings/improvement-suggestions', element: withAppLayout(<ImprovementSuggestionsPage />) },
  {
    path: '/settings/order-workflow/types/:typeId/edit',
    element: <OrderWorkflowEditorRedirect />,
  },
  {
    path: '/settings/order-workflow',
    element: withAppLayout(<Navigate to="/orders/workflow/catalog" replace />),
  },
  {
    path: '/settings/order-workflow/:section',
    element: withAppLayout(<OrderWorkflowSectionRedirect />),
  },
  { path: '/workspaces/new', element: withAppLayout(<CreateWorkspacePage />) },
];
